<template lang="pug">
.cp-success-team
  .w
    .title 去电客户成功团队
    .list
      .item(v-for="(v1, index) in list", :class="'bg' + index")
        icon.icon(:iconClass="v1.icon")
        p.item-title {{v1.title}}
        p.item-subtitle {{v1.subtitle}}
        .content
          p(v-for="v2 in v1.content") {{v2}}
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      list: [
        { icon: 'iconjingli', title: '项目成功经理', subtitle: '对流程效率负责', content: ['运营流程管理', '客户资料归档及账户开通审核', '线路/硬件资源配置管理', '客户台账、结算、业绩报表'] },
        { icon: 'iconshejishi', title: 'VUI语音交互设计师', subtitle: '对话术质量负责', content: ['设计话术内容', '维护行业领域知识库', '复核已配置的话术', '监督优化话术质量'] },
        { icon: 'iconzhuanjia', title: '行业运营专家', subtitle: '对业务转化负责', content: ['受理售后客户问题', '受理跟进运营中心工单', '负责客户在线培训、各文档输出', '在线解决客户各类疑问'] },
      ]
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
.cp-success-team
  .bg0
    background url('../../../assets/jingli.png') center / 100% no-repeat
  .bg1
    background url('../../../assets/shejishi.png') center / 100% no-repeat
  .bg2
    background url('../../../assets/zhuanjia.png') center / 100% no-repeat
  .list
    margin-top 80px
    margin-bottom 200px
    padding 0px 65px
    display flex
    justify-content space-between
    .item
      width 320px
      height 400px
      padding-top 40px
      padding-left 40px
      // background linear-gradient(136deg,rgba(8,27,65,0.7) 0%,rgba(7,41,97,0.9) 100%)
      .icon
        font-size 45px
        margin-bottom 30px
      .item-title
        font-size 24px
        color rgba(244,245,247,1)
        margin-bottom 19px
      .item-subtitle
        font-size 18px
        color rgba(158,234,250,1)
      .content
        margin-top 57px
        p
          line-height 28px
</style>
